import { LobCode } from 'omni-package-react-core';
import { OnlineTransactionDto } from '../../interfaces/OnlineTransactionDto';
import { Notification } from '../../interfaces/Notification';

export default function transformOnlineTransactionData(onlineTransactionDto: OnlineTransactionDto): Notification[] {
  const onlineTransaction: Notification[] = [];

  onlineTransactionDto?.data?.forEach((dto) => {
    const elem: Notification = {
      id: dto.transactionId,
      text: dto.description,
      sector: dto.sectorCode as LobCode,
      url: dto.url,
      creationDateUtc: new Date(),
      isDeleting: false,
      seen: false,
      type: 'actionrequired',
      visited: false,
      source: 'transaction',
    };
    onlineTransaction.push(elem);
  });
  return onlineTransaction;
}
